import React, {createContext, useState} from 'react';

const stepContext = createContext({});

const StepProvider = ({children}:any) => {
    const [view, setView] = useState("");

    return (
        <stepContext.Provider value={{view, setView}}>
            {children}
        </stepContext.Provider>
    );
};

export {StepProvider, stepContext};